import { AxiosInstance } from 'axios'
import { PositionKind, Role } from '@/api/consts'

export function getPositionEventsTable(
  axios: AxiosInstance,
  kinds: Array<PositionKind>,
  startDate: string,
  endDate: string
) {
  return axios({
    url: '/v1/references/events/period',
    method: 'post',
    data: { kinds, start_date: startDate, end_date: endDate },
  })
}

export function getListenerCourseStatusTableResponse(axios: AxiosInstance, courseId: string) {
  return axios({
    url: `/v1/references/courses/${courseId}`,
    method: 'get',
  })
}

export function getSitesPostsTableResponse(
  axios: AxiosInstance,
  startDate?: string,
  endDate?: string,
  region?: string
) {
  let url = `/v1/references/sites/posts?start_date=${startDate}&end_date=${endDate}`
  if (region) {
    url += `&region=${region}`
  }
  return axios({
    url,
    method: 'get',
  })
}

export function getSitesMetrikaResponse(
  axios: AxiosInstance,
  startDate: string,
  endDate: string,
  region: string
) {
  let url = `/v1/references/sites/metrika?start_date=${startDate}&end_date=${endDate}&site_key=${region}`
  return axios({
    url,
    method: 'get',
  })
}

export function getSitesMetrikaHTMLResponse(
  axios: AxiosInstance,
  startDate: string,
  endDate: string,
  region: string
) {
  let url = `/v1/references/sites/metrika/html?start_date=${startDate}&end_date=${endDate}&site_key=${region}`
  return axios({
    url,
    method: 'get',
    // responseType: 'text',
  })
}
